module.exports = __webpack_public_path__ + "static/media/company_logo_en.5f675f71.png";